import { Button } from "antd"
import styled from "styled-components"

export const TutorialDiv = styled.div`
    max-width: 250px;
`
export const TutorialButton = styled(Button)`
    width: 100%;
`
